const initialState = {
  selected: {},
  mixables: []
}

const mixables = (state = initialState, action) => {
  switch (action.type) {
    case 'ADD_MIXABLES':
      return Object.assign({}, state, {
        mixables: action.mixables
      })
    case 'SELECT_MIXABLE':
      return Object.assign({}, state, {
        selected: action.mix
      })
    case 'REMOVE_MIXABLES':
      return Object.assign({}, state, {
        mixables: [],
        selected:{}
      })
    default:
      return state
  }
}

export default mixables;
